export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6524.0cd0728c.jpg";